export default "__VITE_ASSET__BjEI7$Gp__"